import { type KktuResponse } from '@synapex/shared2/gateway-rest-api'

export const fullItemText = (
    data: KktuResponse,
    code: string | null | undefined,
    fallback = ''
) =>
    code && data.record[code] ? `${code} ${data.record[code].name}` : fallback

export const filterSearch = (
    data: KktuResponse,
    searchArg: string
): { code: string; name: string }[] => {
    if (!searchArg) {
        return data.order.map((code) => ({
            code,
            name: data.record[code].name,
        }))
    }

    const search = searchArg.toLocaleLowerCase()
    const list: { code: string; name: string; searchPos: number }[] = []
    let needFilter = false

    for (const code of data.order) {
        const name = data.record[code].name

        let searchPos = -1
        if (search) {
            searchPos = code.search(search)

            if (searchPos < 0) {
                searchPos = name.toLocaleLowerCase().search(search)
            }
        }
        needFilter = needFilter || searchPos >= 0

        list.push({ code, name, searchPos })
    }

    if (needFilter) {
        return list
            .filter((item) => item.searchPos >= 0)
            .sort((a, b) => (a.searchPos < b.searchPos ? -1 : 1))
    }

    return list
}
